<article class="about-metric-card" *ngIf="metric">
  <h3>{{ metric.value }}</h3>
  <p>{{ metric.label }}</p>
</article>
